import type { DataSourceEntity } from '@unifyapps/defs/types/dataSource';
import { getIdWithPrefix } from '../../../../utils/id';
import { REQUEST_ID_PREFIX } from '../../../const';
import DataSourceHelper from '../../../helper/DataSourceHelper';
import type { DataSourceControllerState } from '../types';

export const getInitialManuallyTriggeredDataSources = (
  dataSources?: Record<string, DataSourceEntity | undefined>,
) => {
  const manualDS = dataSources ? DataSourceHelper.getManualPageLoadDataSources(dataSources) : [];

  return manualDS.reduce<DataSourceControllerState['manuallyTriggeredDataSources']>((acc, ds) => {
    const key = getIdWithPrefix(REQUEST_ID_PREFIX);
    acc[key] = {
      callback: () => Promise.resolve(),
      dataSourceId: ds.id,
    };
    return acc;
  }, {});
};
